<template>
  <el-dialog title="上传图片" :visible="visible" width="1200px" @close="dialogClose">
    <div class="uploadBox">
      <el-form :model="ruleForm" ref="ruleForm" class="backgroundForm" label-width="120px">
        <el-form-item label="模板名称:" required>
          <el-input v-model="ruleForm.templateName" maxlength="15" show-word-limit placeholder="请填入" style="width: 400px"></el-input>
        </el-form-item>
        <el-form-item label="上传图片:" required>
          <div style="display: flex;">
            <el-upload class="upload-demo" action="#" :on-remove="handleRemove" multiple :limit="1" :on-change="handleChange">
              <el-button size="small" type="primary">点击上传</el-button>
              <!-- <div slot="tip" class="el-upload__tip">只能上传jpg/png文件，且不超过500kb</div> -->
            </el-upload>
            <span style="margin-left: 20px;color:red">注意：建议上传尺寸：630px*788px 图片大小：3M以内 （建议尽量小，避免影响加载速度） 格式：jpg、png、gif</span>
          </div>
        </el-form-item>
        <div class="imgbox" v-if="ruleForm.templateUrl">
          <img :src="ruleForm.templateUrl" alt="" />
        </div>
      </el-form>
    </div>
    <span slot="footer" style="display: flex;justify-content: end;margin-right: 60px;">
      <el-button @click="dialogClose()">取消</el-button>
      <el-button type="primary" @click="nextStep()">确定</el-button>
    </span>
  </el-dialog>
</template>

<script>
import { uploadpic } from "@/api/paradiseAndTaskCommonController.js";

export default {
  props: {
    visible: {
      default: false,
    },
  },
  data() {
    return {
      ruleForm: {
        openType: 1,
        templateName: "",
        giftPrizeType: 0,
        giftType: 0,
        templateUrl: "",
        expirationType: 0,
        openMerchant: this.$store.state.loginUserInfo.sellerNick,
      },
      giftPopup: false,
      navList: [],
      tabActive: 0,
      giftList: [],
      pageData: {
        size: 10,
        current: 1,
        total: 0,
      },
      fileList: [],
    };
  },
  async created() {},
  methods: {
    nextStep() {
      if (!this.ruleForm.templateName) {
        return this.$message.warning("请输入模板名称");
      }
      if (!this.ruleForm.templateUrl) {
        return this.$message.warning("请上传图片");
      }
      // console.log(this.ruleForm);
      this.$emit("handleSave", { ...this.ruleForm });
      setTimeout(() => {
        this.ruleForm.templateName = "";
        this.ruleForm.templateUrl = "";
      }, 1000);
    },
    //上传图片
    handleChange(file, fileList) {
      this.fileList = fileList;

      // this.$refs.upload.$children[1].$el.style.display = "none";
      // this.objectForm.name = file.name;
      let formdata = new FormData();
      formdata.append("file", file.raw);
      uploadpic(formdata).then((res) => {
        // 获取图片真实url
        this.ruleForm.templateUrl = res.data;
      });
    },
    handleRemove(file, fileList) {
      console.log(file, fileList);
    },
    dialogClose() {
      this.$emit("update:visible", false);
    },
  },
};
</script>

<style lang="scss" scoped>
/deep/ .el-upload-list {
  display: none;
}
/deep/ .el-dialog__body {
  border-bottom: 1px solid #f0f0f0;
}
.uploadBox {
  height: 60vh;
  overflow: auto;
}
.imgbox {
  width: 224px;
  height: 433px;
  box-sizing: border-box;
  background: rgba(123, 97, 255, 0.05);
  border-radius: 8px;
  border: 1px solid #dcdfe6;
  display: flex;
  align-items: center;
  justify-content: center;
  margin-left: 120px;
  img {
    max-width: 224px;
    width: 100%;
  }
}
</style>
